import { render, staticRenderFns } from "./referafriend.vue?vue&type=template&id=68b47ded&scoped=true&"
import script from "./referafriend.vue?vue&type=script&lang=js&"
export * from "./referafriend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b47ded",
  null
  
)

export default component.exports